/* Redirects */
const domain = new URL(window.location.href);

/*
Key value object
'From': 'To',
Url matching the 'From' path will be redirected to the 'To' path
Wildcards and relative paths can be used. From path will be checked using include function of current domain href. To locations can be relative or static.
Watch out for case sensitivity and special characters
 */
const redirectPaths = {
  "/?utm_campaign=ptv-packaging2023&utm_medium=offline&utm_source=packaginginsert&utm_content=cr-printed_pt-na&utm_term=": "/pages/warranty-registration",
  "/?utm_campaign=nbm-petivity2021&utm_medium=offline&utm_source=package&utm_content=cr-application_link_pt-na&utm_term=":
    "https://apps.apple.com/us/app/petivity-cat/id1500596230",
  "/?utm_campaign=nbm-petivity2021&utm_medium=offline&utm_source=package&utm_content=cr-user%20manual_pt-na&utm_term=":
    "/pages/smart-litterbox-monitor-set-up-user-guide?utm_campaign=ptv-website2023&utm_medium=offline&utm_source=packagingqrcode&utm_content=cr-packaging%20link%20to%20setup%20guide_pt-na&utm_term=",
  "/collections/vendors": "/products/smart-litterbox-monitor",
};

/** check for wildcard redirects **/
for (const originalPath in redirectPaths) {
  const redirectTo = redirectPaths[originalPath];
  const includesDomain = redirectTo.startsWith("http");
  if (domain.href.includes(originalPath)) {
    if (includesDomain) {
      window.location = redirectTo;
    } else {
      window.location = domain.protocol + "//" + domain.hostname + redirectTo;
    }
  }
}

if (window.location.pathname === '/pages/warranty') {
  const warrantyPage = () => {
    const startMessengerWarrantyChat = () => {
      astuteBotMessenger.sendEvent(
        { name: "Bot", index: 0 },
        {
          type: "startConversation",
          initialUserMessage: { type: "event", content: { type: 0 } },
        }
      );
    }
    const sleepWarrantyChat = ms => {
      return new Promise((resolve) => setTimeout(resolve, ms));
    }
    // launches chat bot 'activate warranty' discussion
    const startWarrantyChat = async () => {
      await sleepWarrantyChat(2000);
      startMessengerWarrantyChat();
    }
    // activate button - launches chat bot 'activate warranty' discussion
    const buttonWarrantyChat = () => {
      const buttons = document.querySelectorAll('.button-warranty-chatbox');
      buttons.forEach(button => {
        button.addEventListener('click', () => {
          startWarrantyChat();
        })
      })
    }
    buttonWarrantyChat();
    if (window.location.search === '?chatbot=true') {
      startWarrantyChat();
    }
  }
  warrantyPage();
}